import * as jQuery from 'jquery';
import * as _ from 'underscore';

import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { DatatableComponent } from '@swimlane/ngx-datatable';

import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { UtilityService } from '../../../../core/utility/services/utility.service';
import { DownloadConfig } from '../../../analytics-core/interfaces/widget.interface';
import { EVENT_EMITTERS } from '../../../analytics/constants/analytics.constants';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { ModalService } from '../../../shared/directives/modal/modal.service';
import { WidgetCore } from '../../interfaces/widget.core.interface';
import { NetworkDetail } from '../creative-detail-v2/creative-detail.interface';

@Component({
	selector: 'app-tv-network-program-v1',
	styleUrls: ['./tv-network-program-v1.component.css'],
	templateUrl: './tv-network-program-v1.component.html'
})
export class TvNetworkProgramV1Component implements OnInit, WidgetCore, OnDestroy {
	public key: string;
	public showLoad = true;
	public hasData: boolean;
	public placeholderimage: string;
	public isPreroll: boolean;
	@Input() sectiontitle;
	@Input() downloadconfig: string;
	@Input() sectionclass: any;
	@ViewChild(DatatableComponent) table: DatatableComponent;

	public partnerName: string;
	public downloadConfiguration: DownloadConfig;
	public networks: NetworkDetail[] = [];
	public networkDetail = {} as NetworkDetail;
	public totalCreatives: number;
	public displayIndex: any;
	public count: any;
	public reloadSubscription;
	public widgetDataSubscription;
	public selectedNetwork: NetworkDetail;
	public processedNetworks;
	public columns = [
		{ name: 'Program', prop: 'program', className: 'programClass' },
		{ name: 'Exposures', prop: 'exposure', className: 'exposureClass' }
	];
	public programs;
	public tableLimit = 10;
	public downloadIcon: any = false;
	public allowForTelevision: boolean = false;
	public isR103: boolean = false;
	testdata: Array<{ network_name: string; program_name: string; airings: string; thumbnail_url: string }>;

	constructor(
		protected analyticsService: AnalyticsService,
		protected modalService: ModalService,
		protected sanitizer: DomSanitizer,
		protected analyticsDataModel: AnalyticsDataModel
	) {
		this.reloadSubscription = EmitterService.get(EVENT_EMITTERS.RELOAD).subscribe((response: any) => {
			this.requestData();
		});
	}

	ngOnInit(): void {
		this.downloadConfiguration = JSON.parse(decodeURI(this.downloadconfig));
		this.allowForTelevision = this.analyticsDataModel.config.directoryName.includes('r102') ? true : false;
		this.isR103 =
			this.analyticsDataModel.config.directoryName.toLowerCase() === 'default-r103' ||
			this.analyticsDataModel.config.directoryName.toLowerCase() === 'entravision-r103'
				? true
				: false;
		this.partnerName = this.analyticsDataModel.partner.partnerName;
		this.downloadIcon = this.analyticsDataModel.config.downloadIcon
			? this.analyticsDataModel.config.downloadIcon
			: this.downloadIcon;
		if (this.isR103) {
			this.tableLimit = 5;
		}
		this.requestData();
	}

	ngOnDestroy(): void {
		if (this.reloadSubscription) {
			this.reloadSubscription.unsubscribe();
		}
		if (this.widgetDataSubscription) {
			this.widgetDataSubscription.unsubscribe();
		}
		this.selectedNetwork = undefined;
	}

	reset(): void {
		this.table.sorts = [];
		this.table.offset = 0;
	}

	requestData(): void {
		this.hasData = true;
		this.showLoad = true;
		this.count = 1;
		this.widgetDataSubscription = this.analyticsService.processWidgetRequest(this.key).subscribe((response: any) => {
			this.showLoad = false;
			if (response.success) {
				this.hasData = true;
				this.processResponseData(response.data);
			} else {
				this.hasData = false;
				this.networks = [];
				this.totalCreatives = 0;
				this.networkDetail = {} as NetworkDetail;
			}
		});
	}

	processResponseData(responseData: any): void {
		if (responseData.length > 0) {
			responseData.map((data) => {
				if (!data.creative_name) {
					data['creative_name'] = data.name;
				}
			});
			this.networks = this.mapResponseDataToInterface(responseData);
			const groupedNetworks = _.groupBy(this.networks, (network: any) => {
				return network.networkName;
			});
			this.processedNetworks = this.processNetworkData(groupedNetworks);
			this.displayIndex = this.processedNetworks.length - 1;
			this.totalCreatives = this.processedNetworks.length;
			this.setSlide();
			this.setDisplayIndexContent(this.displayIndex);
		} else {
			this.hasData = false;
		}
	}

	processNetworkData(networkData: any): any[] {
		const finalNetworks = [];
		const keys = _.keys(networkData);
		for (const key of keys) {
			const networksObj = {};
			const programs = [];
			let thumbnail = '';
			let marphedlogo = '';
			for (const network of networkData[key]) {
				thumbnail = network.thumbnail_url;
				marphedlogo = network.marphedlogo;
				programs.push({ program: network.program, exposure: network.airings });
			}
			// sorting program
			// tslint:disable-next-line: only-arrow-functions
			programs.sort(function (a: any, b: any): number {
				if (a.program.toLowerCase() === 'n/a' || b.program.toLowerCase() === 'n/a') {
					return b.program.toLowerCase() === 'n/a' ? -1 : 1;
				} else if (a.program.toLowerCase() === 'generic' || b.program.toLowerCase() === 'generic') {
					return b.program.toLowerCase() === 'generic' ? -1 : 1;
				} else if (a.program.toLowerCase() === 'to be announced' || b.program.toLowerCase() === 'to be announced') {
					return b.program.toLowerCase() === 'to be announced' ? -1 : 1;
				} else if (a.exposure === b.exposure) {
					return a.program > b.program ? 1 : -1;
				} else {
					return a.exposure < b.exposure ? 1 : -1;
				}
			});

			networksObj['networkName'] = key;
			networksObj['thumbnail'] = thumbnail;
			networksObj['marphedlogo'] = marphedlogo;
			networksObj['programs'] = programs;
			finalNetworks.push(networksObj);
		}
		return finalNetworks;
	}

	setSlide(): void {
		this.nextArrow();
		this.prevArrow();
		this.checkFontSize();
	}
	checkFontSize(): void {
		let elems;
		setTimeout(() => {
			elems = document.querySelectorAll('#tvNnPLogo');
			for (const elem of elems) {
				jQuery(elem).css({ 'font-size': '130px' });
				this.reduceFontSize(elem);
			}
		}, 0);
	}
	reduceFontSize(element: any): void {
		if (element.scrollWidth > element.parentElement.clientWidth) {
			const fontSize = parseInt(element.style.fontSize, 10) - 1;
			if (fontSize > 1) {
				element.style.fontSize = fontSize + 'px';
				this.reduceFontSize(element);
			}
		}
	}

	setDisplayIndexContent(displayIndex: number): void {
		if (this.processedNetworks.length > 0) {
			this.networkDetail = this.processedNetworks[displayIndex];
			this.programs = this.networkDetail['programs'];
		} else {
			this.networkDetail = {} as NetworkDetail;
		}
	}

	nextArrow(): void {
		this.reset();
		if (this.processedNetworks.length > 1) {
			if (this.displayIndex === 0) {
				this.displayIndex = this.processedNetworks.length - 1;
				this.setDisplayIndexContent(this.displayIndex);
			} else {
				this.displayIndex = this.displayIndex - 1;
				this.setDisplayIndexContent(this.displayIndex);
			}
		}
		if (this.count === 1) {
			this.count = this.processedNetworks.length;
		} else {
			this.count = this.count - 1;
		}
		this.checkFontSize();
	}

	prevArrow(): void {
		this.reset();
		if (this.processedNetworks.length > 1) {
			if (this.processedNetworks.length - 1 === this.displayIndex) {
				this.displayIndex = 0;
				this.setDisplayIndexContent(this.displayIndex);
			} else {
				this.displayIndex = this.displayIndex + 1;
				this.setDisplayIndexContent(this.displayIndex);
			}
		}
		if (this.processedNetworks.length === this.count) {
			this.count = 1;
		} else {
			this.count = this.count + 1;
		}
		this.checkFontSize();
	}
	mapResponseDataToInterface(responseData: any): NetworkDetail[] {
		const networkPerformances: NetworkDetail[] = [];
		for (const response of responseData) {
			const networkObj: NetworkDetail = {} as NetworkDetail;
			networkObj.networkName = response.network_name
				? response.network_name
				: response.name
				? response.name
				: response.ad_headline;
			networkObj.airings = UtilityService.isUndefinedOrNull(response.airings) ? 0 : parseFloat(response.airings);
			if (response.thumbnail_url) {
				networkObj.thumbnail_url = response.thumbnail_url;
			}
			if (!response.thumbnail_url) {
				networkObj.marphedlogo = response.network_name ? response.network_name.split(/\s+/).slice(0, 4).join(' ') : '';
			}

			networkObj.program = response.program_name;
			networkPerformances.push(networkObj);
		}
		return networkPerformances;
	}

	downloadDataInCSV(event: any): void {
		event.preventDefault();
		this.analyticsService.downloadCSV(this.downloadConfiguration.csvQueryKey, this.downloadConfiguration.fileName);
	}
}
